import React, {useEffect, useState} from "react";
import {Image, Modal, Pressable, View} from "react-native";
import icon from "../assets/img/circle-close-icon.png";
import MainStyle from "../../MainStyle";
import Lottie from "lottie-react";
import tutorial_1_1_2_3 from "../assets/lottie/tutorial_1-1-2-3.json";
import tutorial_2_1 from "../assets/lottie/tutorial_2-1.json";
import tutorial_2_2 from "../assets/lottie/tutorial_2-2.json";
import tutorial_3_1 from "../assets/lottie/tutorial_3-1.json";
import tutorial_3_2 from "../assets/lottie/tutorial_3-2.json";
import tutorial_3_3 from "../assets/lottie/tutorial_3-3.json";
import tutorial_4_1 from "../assets/lottie/tutorial_4-1.json";
import tutorial_4_2 from "../assets/lottie/tutorial_4-2.json";
import tutorial_4_3 from "../assets/lottie/tutorial_4-3.json";
import Logo_SMG from "../assets/img/evenplay-logo-long.svg";
import FadeView from "../components/FadeView";
import Div from "../lib/Div";
import {colors} from "../assets/styles/colors";
import P from "../lib/P";

const register = [
  {header: 'Register', data: tutorial_1_1_2_3, other: 'We’ll start you off with 10 Free Shots'}
];

const enterContest = [
  {header: 'Enter a Challenge', data: tutorial_2_1, other: 'Choose your Distance, Win Circle, and Pay Table'},
  {
    header: 'Enter a Challenge',
    data: tutorial_2_2,
    other: 'Select the “Enter Challenge” button and Confirm Challenge Entry'
  }
];

const takeShot = [
  {header: 'Take a Shot', data: tutorial_3_1, other: 'You’ll see your name on the screen with your challenge active'},
  {header: 'Take a Shot', data: tutorial_3_2, other: 'Choose your club and place a ball in the hitting area'},
  {header: 'Take a Shot', data: tutorial_3_3, other: 'Swing away!'}
];

const getPaid = [
  {header: 'Get Paid!', data: tutorial_4_1, other: "If your ball lands within the Win Circle, you'll win"},
  {header: 'Get Paid!', data: tutorial_4_2, other: "The closer you get, the more you'll win!"},
  {header: 'Get Paid!', data: tutorial_4_3, other: 'Use the Web App to deposit or withdraw money easily'}
];

type Props = { visible: boolean, onResume: () => void, logged: boolean };

const TutorialModal = (props: Props) => {
  const {visible, logged} = props;
  const [animationIndex, setAnimationIndex] = useState(0);
  const animations = [...(logged ? [] : register), ...enterContest, ...takeShot, ...getPaid];
  const [showPreview, setShowPreview] = useState(true);

  const onLoopComplete = () => {
    if (animationIndex + 1 === animations.length) props.onResume();
    else setAnimationIndex(prevState => prevState + 1);
  };

  useEffect(() => {
    if (visible) {
      setTimeout(() => {
        setShowPreview(false);
      }, 2000);

    } else {
      setShowPreview(true);
      setAnimationIndex(0);
    }
  }, [visible]);

  return (
    <Modal animationType="fade" transparent visible={visible} statusBarTranslucent={false} hardwareAccelerated={false}
           onRequestClose={() => props.onResume()}>
      <View style={styles.wrap}>
        <Div w={240} maxH={385} rounded={4} borderWidth={1} borderColor={colors.popupBorder} bg={colors.new_input_color}
             position="relative" py={10}>
          <Pressable style={styles.icon_s} onPress={() => props.onResume()}>
            <Image source={icon} style={styles.img_s}/>
          </Pressable>

          {showPreview ? (
            <FadeView duration={300} showDuration={1400} style={[MainStyle.h_300, MainStyle.a_i_c, MainStyle.j_c_c]}>
              <P color={colors.lightBlue} ta="center" fw="600" fs={20}>Here’s how to play</P>
              <Image source={Logo_SMG as any} style={styles.logo_s}/>
            </FadeView>
          ) : (
            <>
              <P color={colors.lightBlue} ta="center" fw="600" fs={20}>{animations[animationIndex].header}</P>

              <Lottie
                animationData={animations[animationIndex].data} style={{width: '100%', height: '100%'}}
                onLoopComplete={onLoopComplete} loop
              />
            </>
          )}

          <P ta="center" mx={8}>{showPreview ? '' : animations[animationIndex].other}</P>
        </Div>
      </View>
    </Modal>
  );
};

const styles = {
  wrap: [
    MainStyle.full_h, MainStyle.full_w, MainStyle.bc_modalBg, MainStyle.fix_gradient_and_modal_error_in_landscape,
    MainStyle.flex, MainStyle.a_i_c, MainStyle.j_c_c, MainStyle.p_y_70
  ],
  icon_s: [MainStyle.absolute, MainStyle.t__28, MainStyle.r__28],
  img_s: [MainStyle.w_28, MainStyle.h_28],
  logo_s: [MainStyle.full_w, MainStyle.h_176, MainStyle.rm_center]
};

export default React.memo(TutorialModal);
